import React from 'react';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-[#f4fbff] to-white text-center px-6">
      <p className="text-sm uppercase tracking-[0.4em] text-lumin-primary/80">Lost signal</p>
      <h1 className="text-5xl font-semibold mt-4 text-slate-900">404</h1>
      <p className="text-slate-500 mt-4 max-w-xl">
        We couldn’t find that view in the new onboarding experience. Double-check the link or return to your dashboard.
      </p>
      <a href="/" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-lumin-accent">
        ⟵ Back to home
      </a>
    </div>
  );
};

export default NotFound;
